import { AxiosError } from 'axios';
import { isArray, isPlainObject, isString, uniq } from 'lodash';

type ValidationErrorBody = {
	message?: unknown;
	errors?: unknown;
};

export const getApiErrorMessages = (error: unknown): string[] => {
	const body = (error as AxiosError<ValidationErrorBody> | undefined)?.response
		?.data;
	if (!body) return [];
	if (isPlainObject(body.errors)) {
		const messages = Object.values(body.errors as Record<string, unknown>)
			.flatMap((value) => (isArray(value) ? value : [value]))
			.filter(isString);
		if (messages.length) return uniq(messages);
	}
	return isString(body.message) && body.message ? [body.message] : [];
};
